<iui-messages #messages class="ms-auto me-auto"> </iui-messages>

<div *ngIf="order || payment" class="float-end">
    <button class="btn btn-primary" (click)="printReceipt()">Print Receipt</button>
    <button class="btn btn-primary ms-3" (click)="downloadPdf()">Download Receipt</button>
</div>
<div *ngIf="order">
    <h2 class="col-md-6"> Receipt: {{ orderId }} </h2>
</div>
<div *ngIf="payment">
    <h2 class="col-md-6"> Receipt: {{ paymentId }} </h2>
</div>

<div *ngIf="order || payment" class="mt-5 row">
    <div *ngIf="order" class="col-md-4">
        <h3>Customer</h3>
        <div class="truncate" [pTooltip]="order.company || ''" tooltipPosition="top" appShowToolTipIfTruncated>{{ order.company }}</div>
        <div>{{ order.billingFirstName }} {{ order.billingLastName }}</div>
        <div class="truncate" [pTooltip]="order.billingAddress1 || ''" tooltipPosition="top" appShowToolTipIfTruncated>{{ order.billingAddress1 }}</div>
        <div class="truncate" [pTooltip]="order.billingAddress2 || ''" tooltipPosition="top" appShowToolTipIfTruncated>{{ order.billingAddress2 }}</div>
        <div>{{ order.billingCity }}<span *ngIf="order?.billingState">,</span> {{ order.billingState }} {{ order.billingZip }}</div>
        <div>{{ order.billingCountry | scrConfig:'country' }}</div>
    </div>
    <div *ngIf="payment" class="col-md-4">
        <h3>Customer</h3>
        <div class="truncate" [pTooltip]="payment.company || ''" tooltipPosition="top" appShowToolTipIfTruncated>{{ payment.company }}</div>
        <div>{{ payment.billingFirstName }} {{ payment.billingLastName }}</div>
        <div class="truncate" [pTooltip]="payment.billingAddress1 || ''" tooltipPosition="top" appShowToolTipIfTruncated>{{ payment.billingAddress1 }}</div>
        <div class="truncate" [pTooltip]="payment.billingAddress2 || ''" tooltipPosition="top" appShowToolTipIfTruncated>{{ payment.billingAddress2 }}</div>
        <div>{{ payment.billingCity }}<span *ngIf="payment.billingState">,</span> {{ payment.billingState }} {{ payment.billingZip }}</div>
        <div>{{ payment.billingCountry | scrConfig:'country' }}</div>
    </div>
    <div class="col-md-4">
        <h3>Details</h3>
        <ng-template [ngIf]="!scId && orderId && order">
            <div><strong>Order Id</strong>: {{ orderId }}</div>
            <div><strong>Customer Number</strong>: {{ order.accountId }}</div>
            <div><strong>PO Number</strong>: {{ order.poNumber }}</div>
            <div><strong>Payment Date</strong>: {{ order.paymentReceivedDate | date:'longDate' }}</div>
            <div><strong>Payment Method</strong>: {{ order.paymentMethod }}</div>
            <div *ngIf="order.lastFourDigits"><strong>Account Number</strong>: Ending in {{ order.lastFourDigits }}</div>
            <div *ngIf="order.checkNumber"><strong>Check Number</strong>: {{ order.checkNumber }}</div>
        </ng-template>
        <ng-template [ngIf]="payment">
            <div><strong>Customer Number</strong>: {{ payment.accountId }}</div>
            <div><strong>PO Number</strong>: {{ payment.poNumber }}</div>
            <div><strong>Payment Date</strong>: {{ payment.paymentReceivedDate | date:'longDate' }}</div>
            <div><strong>Payment Method</strong>: {{ payment.paymentMethod }}</div>
            <div *ngIf="payment?.lastFourDigits"><strong>Account Number</strong>: Ending in {{ payment.lastFourDigits }}</div>

        </ng-template>
        <ng-template [ngIf]="scId && order">
            <div><strong>Invoice</strong>: {{ orderId }}-{{ scId }}</div>
            <div><strong>Invoice Date</strong>: {{order.invoiceDate | date:'longDate'}}</div>
            <div><strong>Customer Number</strong>: {{ order.accountId }}</div>
            <div><strong>PO Number</strong>: {{ order.poNumber }}</div>
            <div><strong>Order Id</strong>: {{ (order.leases || [])[0].orderId }}</div>
            <div><strong>Order Start Date</strong>: {{ (order.leases || [])[0].startDate | date:'longDate' }}</div>
            <div><strong>Order End Date</strong>: {{ (order.leases || [])[0].endDate | date:'longDate' }}</div>
            <div><strong>Payment Period</strong>: {{ order.startDate | date:'MMMM yyyy' }}</div>
        </ng-template>
    </div>
</div>

<div *ngIf="order || payment">
    <hr />

    <h3 *ngIf="scId" class="my-5">Total: {{ sumOfLeaseAmounts | scrMoney }}</h3>
    <h3 *ngIf="!scId && orderId" class="my-5">Total Amount Paid: {{ displayOnlyOrder?.totalPrice | scrMoney }}</h3>
    <h3 *ngIf="paymentId" class="my-5">Total Amount Paid: {{ sumOfLeaseAmounts | scrMoney }}</h3>


    <hr />

    <h2 *ngIf="order" i18n class="mt-5">Short Codes in Order</h2>
    <h2 *ngIf="payment" i18n class="mt-5">Orders Paid</h2>
    <ng-template ngIf="!paymentId">
    <p-table #tt id="tt" class="table invoice-table mt-3" [paginator]="true" [rows]="4000" [alwaysShowPaginator]="false"
        currentPageReportTemplate="(Displaying {first} to {last} of {totalRecords})" [showCurrentPageReport]="true" [lazy]="true"
        (onPage)="loadLazyRecieptLoad($event)" [totalRecords]='totalRecords' [value]="(scId ? displayOnlyOrder?.lines : displayOnlyOrder?.leases )|| []">
        <!-- Template paginatorright as a hacky way to add spacing. DO NOT REMOVE!!! -->
        <ng-template pTemplate="paginatorright" let-state></ng-template>
        <ng-template pTemplate="header" let-reciept>
            <tr class="mt-3">
                <th [ngStyle]="{'min-width': col.header === 'Short Code' ? '112px' : ''}" [ngClass]="col.header === 'List Price' || col.header === 'Amount' || col.header === 'Discount' ? 'money' : ''" *ngFor="let col of recieptColumns" style="border-bottom: transparent !important; padding: 0;">
                    <ng-container *ngIf="col.header !== 'Discount'">
                        {{col.header}}
                    </ng-container>
                    <ng-container *ngIf="col.header === 'Discount' && hasDiscount">
                        {{col.header}}
                    </ng-container>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-reciept let-expanded="expanded" let-rowIndex="rowIndex">
            <tr>
                <td>{{rowIndex + 1}}</td>
                <td>{{reciept.description}}</td>
                <td>{{reciept.scId }}</td>
                <td>{{reciept.startDate | scrDatePending }}</td>
                <td>{{reciept.endDate | scrDatePending }}</td>
                <td class="money">{{reciept.listPrice | scrMoney }}</td>
                <td *ngIf="hasDiscount" class="money">
                    <div *ngFor="let discount of reciept.discountList">
                        {{ discount.displayName }}
                    </div>
                    <div *ngIf="reciept.discountAmount">
                        ({{ reciept.discountAmount | scrMoney }})
                    </div>
                </td>
                <td class="money">{{reciept.price | scrMoney}}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="footer">
            <tr *ngIf="!(hasMore | async)">
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td *ngIf="hasDiscount"></td>
                <td>Total:</td>
                <td class="money">{{ (scId ? (displayOnlyOrder?.lines || [{}])[0].price : displayOnlyOrder?.totalPrice) | scrMoney }}</td>
            </tr>
        </ng-template>
    </p-table>
    </ng-template>
    <table class="table receipt-table mt-3" *ngIf="paymentId">
        <thead>
            <th i18n>Line</th>
            <th i18n>Description</th>
            <th i18n>Order ID</th>
            <th i18n>Short Code</th>
            <th i18n>Start Date</th>
            <th i18n>End Date</th>
            <th i18n class="money">List Price</th>
            <th i18n *ngIf="hasDiscount" class="money">Discount</th>
            <th i18n class="money">Amount</th>
        </thead>
        <tbody>
            <tr *ngFor="let lease of displayOnlyOrder?.lines || displayOnlyOrder?.leases || displayLeases || []; let i=index">
                <td>{{ i+1 }}</td>
                <td>{{ lease.description }}</td>
                <td>{{ lease.orderId}}</td>
                <td>{{ lease.scId }}</td>
                <td>{{ lease.startDate | scrDate }}</td>
                <td>{{ lease.endDate | scrDate }}</td>
                <td class="money">{{ lease.listPrice | scrMoney }}</td>
                <td *ngIf="hasDiscount" class="money">
                    <div *ngFor="let discount of lease.discountList">
                        {{ discount.displayName }}
                    </div>
                    <div *ngIf="lease.discountAmount" class="money">
                        ({{ lease.discountAmount | scrMoney }})
                    </div>
                </td>
                <td class="money">{{ lease.price | scrMoney }}</td>
            </tr>
        </tbody>
        <tfoot>
            <tr>
                <td></td>
                <td></td>
                <td *ngIf="paymentId"></td>
                <td></td>
                <td></td>
                <td></td>
                <td *ngIf="hasDiscount"></td>
                <td><strong>Total:</strong></td>
                <td *ngIf="orderId" class="money">{{ (scId ? (displayOnlyOrder?.lines || [{}])[0].price : displayOnlyOrder?.totalPrice) | scrMoney }}</td>
                <td *ngIf="paymentId" class="money">{{ sumOfLeaseAmounts | scrMoney }}</td>

            </tr>
        </tfoot>
    </table>

</div>

<footer *ngIf="config" class="mt-5">
    For billing inquiries please call <strong>{{config.customerSupportPhone}}</strong>
    or send an email to <strong><a class="link" href="mailto: {{config.customerSupportEmail}}">{{config.customerSupportEmail}}</a></strong>.
</footer>